document.querySelectorAll('.btn[href="#donate"]')
.forEach(button => button.textContent = 'Buy a Brick')
document.querySelectorAll('.btn[href$="/brick-by-brick"]')
.forEach(button => button.textContent = 'Main Campaign')
